import React, { useState } from "react";
import config from "../../Config";
import axios from "axios";
import StudentMenu from "./StudentMenu";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RightsCheck from "../General/RightsCheck";

function AdmitStudent() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [searchLoading, setSearchLoading] = useState(false);
  const [admitLoading, setAdmitLoading] = useState(false);
  const [StudentID, setStudentID] = useState("");
  const [Student, setStudent] = useState(null);
  const [admissionDate, setAdmissionDate] = useState("");
  const [allocatedRegNo, setAllocatedRegNo] = useState("");

  document.title = "Admit Student";

  const handleSearch = (event) => {
    event.preventDefault();
    if (!StudentID || StudentID === "0") {
      toast.error("Please enter a valid Student ID.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setSearchLoading(true);
    setAllocatedRegNo("");
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: StudentID,
    };

    axios({
      method: "post",
      url: config.base_url + "Student/GetStudentByIDForAdmit",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setStudent(response.data.Student);
        } else {
          setStudent(null);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setSearchLoading(false);
      })
      .catch(function () {
        setSearchLoading(false);
        setStudent(null);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const admitStudent = (event) => {
    event.preventDefault();
    if (!Student) {
      return;
    }

    setAdmitLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: StudentID,
      AdmissionDate: admissionDate,
    };

    axios({
      method: "post",
      url: config.base_url + "Student/AdmitStudent",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          const regNo = response.data.RegistrationNo || "";
          setAllocatedRegNo(regNo);
          setStudent(null);
          toast.success(
            regNo
              ? `Registration No ${regNo} allocated successfully.`
              : response.data.status_message,
            { position: toast.POSITION.TOP_RIGHT }
          );
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setAdmitLoading(false);
      })
      .catch(function () {
        setAdmitLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const resetForm = () => {
    setStudentID("");
    setStudent(null);
    setAdmissionDate("");
    setAllocatedRegNo("");
  };

  return (
    <>
      <RightsCheck />
      <StudentMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/Home/Index">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="/student/studentdashboard">Students</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Admit Student
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Admit Student</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="card">
                  <div className="card-body card-form-wrap">
                    {allocatedRegNo && (
                      <div className="alert alert-success mb-3">
                        Registration No <strong>{allocatedRegNo}</strong> has
                        been allocated.
                        <button
                          type="button"
                          className="button button-secondary ms-3"
                          onClick={resetForm}
                        >
                          Allocate Another
                        </button>
                      </div>
                    )}

                    <div className="form-wrap">
                      <div className="form-legend">Step 1. Search Student</div>
                      <form onSubmit={handleSearch}>
                        <div className="row align-items-center">
                          <label className="col-md-3 col-form-label col-form-label-sm">
                            Enter Student ID:
                          </label>
                          <div className="col-md-3">
                            <input
                              type="number"
                              name="Student_ID"
                              value={StudentID}
                              onChange={(e) => setStudentID(e.target.value)}
                              className="form-control"
                              required
                            />
                          </div>
                          <div className="col-md-3 offset-md-3">
                            {searchLoading ? (
                              <Spinner animation="border" role="status" />
                            ) : (
                              <button
                                type="submit"
                                className="button button-primary w-100"
                              >
                                Search
                              </button>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>

                    {Student && (
                      <>
                        <div className="form-wrap">
                          <div className="form-legend">
                            Step 2. Confirm Details
                          </div>
                          <div className="row">
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Student Name:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Student_Name}
                              </label>
                            </div>
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Father Name:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Father_Name}
                              </label>
                            </div>
                          </div>
                          <div className="row">
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              F CNIC NO:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Father_CNIC}
                              </label>
                            </div>
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Date of Birth:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Date_Of_Birth}
                              </label>
                            </div>
                          </div>
                          <div className="row no-gutters mb-3">
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Form No:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Form_No}
                              </label>
                            </div>
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Bay Form No:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Bay_Form_No}
                              </label>
                            </div>
                          </div>
                          <div className="row no-gutters mb-3">
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Contact No:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Contact_Mobile}
                              </label>
                            </div>
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Gender:
                            </label>
                            <div className="col-md-4">
                              <label className="label-value">
                                {Student.Gender}
                              </label>
                            </div>
                          </div>
                          <div className="row no-gutters mb-3">
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Wing Name:
                            </label>
                            <div className="col-md-2">
                              <label className="label-value">
                                {Student.SelectedClass?.SelectedWing?.Wing_Name}
                              </label>
                            </div>
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Class Name:
                            </label>
                            <div className="col-md-2">
                              <label className="label-value">
                                {Student.SelectedClass?.Class_Name}
                              </label>
                            </div>
                            <label className="col-md-2 col-form-label col-form-label-sm">
                              Section Name:
                            </label>
                            <div className="col-md-2">
                              <label className="label-value">
                                {Student.SelectedSection?.Section_Name}
                              </label>
                            </div>
                          </div>
                          <div className="row no-gutters mb-3">
                            <label className="col-md-3 col-form-label col-form-label-sm">
                              Temporary Address:
                            </label>
                            <div className="col-md-9">
                              <label className="label-value">
                                {Student.Temporary_Address}
                              </label>
                            </div>
                          </div>
                          <div className="row no-gutters mb-3">
                            <label className="col-md-3 col-form-label col-form-label-sm">
                              Permanent Address:
                            </label>
                            <div className="col-md-9">
                              <label className="label-value">
                                {Student.Permanent_Address}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="form-wrap">
                          <div className="form-legend">
                            Step 3. Allocate Registration No
                          </div>
                          <p className="text-muted small mb-3">
                            This screen only assigns a registration number. Fee
                            is not recorded here.
                          </p>
                          <form onSubmit={admitStudent}>
                            <div className="row align-items-center">
                              <label className="col-md-3 col-form-label col-form-label-sm">
                                Date of Joining (optional):
                              </label>
                              <div className="col-md-3">
                                <input
                                  type="date"
                                  name="admissionDate"
                                  value={admissionDate}
                                  onChange={(e) =>
                                    setAdmissionDate(e.target.value)
                                  }
                                  className="form-control"
                                />
                              </div>
                              <div className="col-md-3 offset-md-3">
                                {admitLoading ? (
                                  <Spinner animation="border" role="status" />
                                ) : (
                                  <button
                                    type="submit"
                                    className="button button-primary w-100"
                                  >
                                    Allocate Registration No
                                  </button>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdmitStudent;
